import { Global } from '@emotion/react'
import { Fragment } from 'react'
import type { WrapPageElementBrowserArgs } from 'gatsby'

import { fontStyles } from './font-styles'
import { useStoreMetrics } from '../hooks/useStoreMetrics'

const MetricsWrapper = ({ pathname }: { pathname?: string }) => {
  useStoreMetrics(pathname)
  return null
}

export const wrapWithGlobalStyles = ({
  element,
  props,
}: WrapPageElementBrowserArgs) => {
  return (
    <Fragment>
      <Global styles={fontStyles} />
      <MetricsWrapper pathname={props.location.pathname} />
      {element}
    </Fragment>
  )
}
